import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/tv-shows';

export default function CategoryNav() {
  const location = useLocation();

  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="flex flex-wrap items-center justify-center gap-2">
        {categories.map((cat) => {
          const isActive = cat.slug === 'all'
            ? location.pathname === '/'
            : location.pathname === `/category/${cat.slug}`;
          return (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isActive
                  ? 'bg-primary-500 text-white shadow-sm'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
              }`}
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.name}
            </Link>
          );
        })}
      </div>
    </section>
  );
}